import React, { useEffect } from 'react';
import Track from './Track'


import { GetPlayer } from '../../hoc/Layout/Layout'

const Playlist = ({playlist, image, tracks, owned, remove}) => {
    const { pid, setPid, setTracks } = GetPlayer()
    const renderTracks = (tracks) => tracks.map((track, i) => (<Track 
        owned={owned}
         item={track.track} 
         remove={remove}
         play={() => {setPid(track.track.id);setTracks(tracks.map(track => track.track.id));}}
         index={i} key={i} />))

         useEffect(()=>{
             if(!pid){
                setPid(tracks[0].track.id)
                setTracks(tracks.map(track => track.track.id))
             }
         }, [])

    return (
        <div 
        className="playlist-page">
            <div className="playlist__cover">
                <div className="playlist__bg" style={{
                backgroundImage: `url('${image}')`
            }}></div>
                <div className="playlist__header">
                    <img src={image}/>
                    <div className="playlist__text">
                        <h3>{playlist.name}</h3>
                        <p>{playlist.description}</p>
                    </div>
                </div>
            </div>
            <div className="playlist__tracks">
                <div className="playlist__track playlist__track--title">
                    <h3 className="track__name">#</h3>
                    <h3 className="track__name">Title</h3>
                    <h3 className="track__artist">Artist</h3>
                    <h3 className="track__album">Album</h3>
                    <h3 className="track__duration">Duration</h3>
                </div>
                { (tracks.length > 0) && renderTracks(tracks) }
            </div>
            
        </div>
    );
}

export default Playlist;
